export default [
  'tania@foodforjoe.es',
  'nuria@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'albane@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'miriam@foodforjoe.es',
  'diego@foodforjoe.es',
  'carla@foodforjoe.es',
  'noelia@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
  'laura.diaz@foodforjoe.es',
];
